import React, { useEffect } from "react";

function ImageSourceModal({
  isOpen,
  title = "Bild auswählen",
  onClose,
  onCamera,
  onGallery,
}) {
  // ✅ Hook IMMER oben
  useEffect(() => {
    if (!isOpen) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  // ❌ erst danach return
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => onClose?.()}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3>{title}</h3>

        <p>Wie möchtest du dein Bild hinzufügen?</p>

        <div className="modal-buttons">
          <button
            className="green-button"
            onClick={() => {
              onCamera?.();
              onClose?.();
            }}
          >
            📷 Foto aufnehmen
          </button>

          <button
            className="green-button"
            onClick={() => {
              onGallery?.();
              onClose?.();
            }}
          >
            🖼 Galerie wählen
          </button>

          <button className="cancel-btn" onClick={() => onClose?.()}>
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImageSourceModal;